import React, { Component } from "react";
import { Modal, Form, Row, Col, Button } from "antd";
import InputForm from "./InputForm";
import "./Form.css";

const { Item: ItemForm } = Form;

export default class ProdutoTamanhoForm extends Component {
  state = {
    registro: {
      ptam_idf: '',
      ptam_descricao: '',
    }
  };


  componentDidUpdate(propsAnterior, stateAnterior) {
    if (this.props.registroSelecionado !== propsAnterior.registroSelecionado) {
      this.setState({
        registro: this.props.registroSelecionado.data,
        visualizar: this.props.registroSelecionado.visualizar,
      }, () => {
        this.refs.ptam_descricao.focus();
      });
    }
  }

  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;

    const { registro } = this.state;
    registro[id] = value;

    this.setState({
      [id]: value
    });
  };

  onOK = () => {
    if ((!this.state.registro.ptam_descricao) || (this.state.registro.ptam_descricao === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Descrição' });
      return;
    }
    this.props.onSalvarClick(this.state.registro);
  };

  render() {
    const { onCancelarClick, carregando, visivel } = this.props;
    const { ptam_idf, ptam_descricao } = this.state.registro;

    return (
      <Modal
        title={ptam_idf ? "Edição de Tamanho Grade" : "Cadastro de Tamanho Grade"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarClick}
        footer={null}
        style={{ top: 30 }}
      >
        <Form>
          <Row>
            <Col xs={24} sm={24}>
              <span>Descrição *</span>
              <InputForm
                id="ptam_descricao"
                ref="ptam_descricao"
                maxLength={30}
                onChange={this.onChange}
                value={ptam_descricao}
                validator={value => Boolean(value)}
              />
            </Col>
          </Row>
          <ItemForm>
            <Row>
              <Col xs={24}>
                {this.state.visualizar ? null : (
                  <Button
                    type="primary"
                    htmlType="button"
                    loading={carregando}
                    onClick={this.onOK}
                    className="btn-salvar"
                  >
                    Salvar
                  </Button>
                )}

                <Button
                  htmlType="button"
                  onClick={onCancelarClick}
                  className="btn-fechar"
                >
                  Fechar
                </Button>
              </Col>
            </Row>
          </ItemForm>

        </Form>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ProdutoTamanhoForm.js